import * as React from "react";
import { useNavigation } from "@react-navigation/native";

import * as routes from "~/constants/routes";
import { LoginBox } from "~/components/auth-screen/components/login-box";
import { KidminSteps } from "~/components/auth-screen/components/kidmin-steps";
import { KidminHeader } from "~/components/auth-screen/components/kidmin-header";
import { BottomLinks } from "~/components/auth-screen/components/bottom-links";

import { Button } from "~/components/button";
import { ButtonTypes } from "~/components/button/types";

import { Container, ButtonBox, KidminContent } from "./styles";
import { messages } from "./intl";

export const KidminIntro = () => {
  const navigation = useNavigation();

  const navigateToSignUp = React.useCallback(
    // @ts-ignore
    () => navigation.navigate(routes.signUp),
    [navigation]
  );

  return (
    <Container>
      <KidminContent>
        <KidminHeader />
        <KidminSteps />
        <ButtonBox>
          <Button
            text={messages.getStarted}
            onPress={navigateToSignUp}
            type={ButtonTypes.Primary}
            isUppercase
          />
          <LoginBox />
        </ButtonBox>
      </KidminContent>
      <BottomLinks />
    </Container>
  );
};
